(() => {
  const bodies = document.querySelectorAll('[data-policy-body]');

  bodies.forEach((body) => {
    const container = body.closest('.tailwhim-policy__article')?.parentElement?.querySelector('[data-policy-toc-container]');
    const toc = container?.querySelector('[data-policy-toc]');
    if (!container || !toc) return;

    const headings = [...body.querySelectorAll('h2, h3')];
    if (!headings.length) {
      container.hidden = true;
      return;
    }

    const usedIds = new Set();
    const list = document.createElement('ul');

    headings.forEach((heading, index) => {
      const fallback = 'policy-section-' + (index + 1);
      const base = (heading.textContent || fallback)
        .trim()
        .toLowerCase()
        .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
        .replace(/^-+|-+$/gu, '') || fallback;
      let id = base;
      let suffix = 2;
      while (usedIds.has(id) || document.getElementById(id)) {
        id = base + '-' + suffix;
        suffix += 1;
      }
      usedIds.add(id);
      heading.id ||= id;

      const item = document.createElement('li');
      item.dataset.policyLevel = heading.tagName.toLowerCase();
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });

    toc.append(list);
    container.hidden = false;
    if (window.matchMedia('(max-width: 989px)').matches) container.removeAttribute('open');
  });
})();
